theme.detectNav = function(){
    var widthLimit = $('.site-header .wrapper').width();
    if ( widthLimit > 768){
        $('.site-header, .info-bar').addClass('showDesktop');
        $('.site-header, .info-bar').removeClass('showMobile');
    }
    else {
        $('.site-header, .info-bar').addClass('showMobile');
        $('.site-header, .info-bar').removeClass('showDesktop');
    }
};
var mobileHowLoopSlider, mobileTermSlider;
var elemHeight;

function showPopup(){
    $("#how-its-works").modal({

    });
    $('#how-its-works .mobileHowitBox.upgrade').each(function(){
            if ($(this).height()) elemHeight = $(this).height()
    })
    $(' #how-its-works .wrap-subscribe-type').each(function(){
        if ($(this).height()) eHeight = $(this).height()
    })
    $(' #how-its-works .wrap-subscribe-type').innerHeight(0)
    $('#how-its-works .mobileHowitBox.upgrade').innerHeight(0)
    if(window.innerWidth < 769){
        initSlider();
    }
}
function HowItWorksStyles(){

    $('.single-section .mobileHowitBox.upgrade').each(function(){
        if ($(this).height()) elemHeight = $(this).height()
    })
    $('.single-section .wrap-subscribe-type').each(function(){
        if ($(this).height()) eHeight = $(this).height()
    })
    $('.single-section .wrap-subscribe-type').innerHeight(0)
    $('.single-section .mobileHowitBox.upgrade').innerHeight(0)
    
    if( window.innerWidth < 769){
        initSlider();
    }
}
function initSlider() {
    mobileHowLoopSlider = $('#MobileHowLoopSlider');
    mobileHowLoopSlider.owlCarousel({
        autoplay: false,
        mouseDrag: true,
        touchDrag: true,
        autoHeight: false,
        nav: false,
        dots: true,
        navText: ['', ''],
        center: false,
        rewind: false,
        loop: true,
        items: 1,
        margin: 0,
        responsive: {
            400: {
                items: 1
            },
            600: {
                items: 1
            },
            800: {
                items: 1
            },
            900: {
                items: 1
            }
        }
    });
    mobileTermSlider = $('.MobileTermSlider');
    mobileTermSlider.owlCarousel({
        autoplay: false,
        mouseDrag: true,
        touchDrag: true,
        autoHeight: true,
        nav: true,
        dots: false,
        navText: ['', ''],
        center: false,
        rewind: false,
        loop: true,
        items: 1,
        margin: 0,
        responsive: {
            400: {
                items: 1
            },
            600: {
                items: 1
            },
            800: {
                items: 1
            },
            900: {
                items: 1
            }
        }
    });
    
    mobileHowLoopSlider.on('changed.owl.carousel', function(event) {

    });
    mobileTermSlider.on('changed.owl.carousel', function(event) {

    })
}
$(document).ready(function(){
    var timeout;
    function fadeOutSubmenu(){
        $('.site-header .child .nav-link').removeClass('active');
        $('.sub-menu .sub-menu-item').stop( true, true ).fadeOut(500);
    }
    function fadeInSubmenu(el){
        $('.sub-menu .sub-menu-item').stop( true, true ).hide();
        $(el).css('display', 'flex');
        $(el).hide();
        $('.sub-menu').stop( true, true ).fadeIn(500);
        $(el).stop( true, true ).fadeIn(500);
    }


    $('.site-header .nav--desktop .child').mouseover(
        function(e){
            $('.site-header .child .nav-link').removeClass('active');
            $(e.target).addClass('active');
        if(e.target.innerText) {
            itemHover = e.target.innerText.trim().toLowerCase();
            
            switch (itemHover) {
                case 'regular box':
                    fadeInSubmenu($('#box_plans-menu'));
                    break;
                
                case 'guide series':
                    fadeInSubmenu($('#guide_series-menu'));
                    break;
                
                case 'crates':
                    fadeInSubmenu($('#crates-menu'));
                	break;
                
                case 'rods + reels':
                    fadeInSubmenu($('#rods-menu'));
                    break;
                
                case 'reels':
                    fadeInSubmenu($('#reels-menu'));
                    break;

                case 'gear + supply':
                    fadeInSubmenu($('#gear_supply-menu'));
                    break;
                
                case 'shop':
                    fadeInSubmenu($('#store-menu'));
                    break;
                
                default:
                    fadeOutSubmenu();

            }
        }
    });

    $('.site-header').mouseleave(function(){
        fadeOutSubmenu();
    });

    $('.links-list a').hover(
        function(){
            var imageName = $(this).attr('data-img');

            var scrImg = $(this).parents('.col').find('img').attr('src');
            var nov_reg = "assets/(.*).png";
            var oldImg = scrImg.match(nov_reg)[1];
            var newString = scrImg.replace(oldImg, imageName);

            $(this).parents('.col').find('img').attr('src', newString)
        }
    );


    $('#featuredImageSlider').owlCarousel({
        nav: false,
        autoplay:true,
        mouseDrag: false,
        touchDrag: true,
        navText: [ '', '' ],
        center: false,
        rewind:false,
        autoHeight:false,
        autoplayTimeout:8000,
        loop:true,
        margin:30,
        responsive:{
            0:{
                items:2
            },
            400:{
                items:2
            },
            600:{
                items:4
            },
            800:{
                items:4
            },
            900:{
                items:6
            }
        },

    });
    
  $('.sts-sponsor-slider').owlCarousel({
        autoplay: true,
        mouseDrag: true,
        touchDrag: true,
        autoHeight: true,
        nav: false,
        dots: false,
        navText: ['', ''],
        center: false,
        rewind: false,
        loop: true,
        items: 6,
        margin: 0,
        responsive: {
            0:{
                items:2
            },
            400: {
                items: 3
            },
            600: {
                items: 4
            },
            800: {
                items: 5
            },
            900: {
                items: 6
            }
        }
    });
  
    $('.sts-sponsor-slider2').owlCarousel({
        autoplay: true,
        mouseDrag: true,
        touchDrag: true,
        autoHeight: true,
        nav: false,
        dots: false,
        navText: ['', ''],
        center: false,
        rewind: false,
        loop: true,
        items: 6,
        margin: 0,
        rtl: true,
        responsive: {
            0:{
                items:2
            },
            400: {
                items: 3
            },
            600: {
                items: 4
            },
            800: {
                items: 5
            },
            900: {
                items: 6
            }
        }
    });
  
    $('.est-sponsor-slider').owlCarousel({
        autoplay: true,
        mouseDrag: true,
        touchDrag: true,
        autoHeight: true,
        nav: false,
        dots: false,
        navText: ['', ''],
        center: false,
        rewind: false,
        loop: true,
        items: 6,
        margin: 0,
        rtl: true,
        responsive: {
            0:{
                items:2
            },
            400: {
                items: 3
            },
            600: {
                items: 4
            },
            800: {
                items: 4
            },
            900: {
                items: 4
            }
        }
    });
  
    $('.est-sponsor-slider2').owlCarousel({
        autoplay: true,
        mouseDrag: true,
        touchDrag: true,
        autoHeight: true,
        nav: false,
        dots: false,
        navText: ['', ''],
        center: false,
        rewind: false,
        loop: true,
        items: 6,
        margin: 0,
        responsive: {
            0:{
                items:2
            },
            400: {
                items: 3
            },
            600: {
                items: 4
            },
            800: {
                items: 4
            },
            900: {
                items: 4
            }
        }
    });

    $('.products-carousel').owlCarousel({
        nav:true,
        autoHeight: true,
        singleItem:true,
        loop: true,
        navText : ["<i class='icon icon-arrow-left'></i>","<i class='icon icon-arrow-right'></i>"]
    });
  
    $('.whatyouget-popup-link').magnificPopup({
        type:'inline',
        midClick: true,
        closeBtnInside: true
    });

    $('#how-its-works').addClass('modal');
    // $('#btn-how-it-works').click(function(){
    //     showPopup();
    // });
    if($(".howitsworkSection").hasClass("single-section")){
    
    HowItWorksStyles();
    }

    $('#shopify-section-sing-up .button a').click(function(e) {
        e.preventDefault();

        $('html, body').animate({
            scrollTop: 0
        }, 500);
    });
});

